import { Expose } from "class-transformer";
import type { UUID } from "crypto";
import type { CurrentAddressTypeEnum } from "../../enums/current-address-type.enum";
import type { HouseholdMemberRelationshipTypeEnum } from "../../enums/household-member-relationship-type.enum";
import type { OtherParentPersonalStatusEnum } from "../../enums/other-parent-personal-status.enum";
import type { RelationshipDynamicsEnum } from "../../enums/relationship-dynamics.enum";
import type { IHouseholdMemberRelationshipDto } from "./household-member-relationship.dto.interface";

export class HouseholdMemberRelationshipDto implements IHouseholdMemberRelationshipDto {
  @Expose()
  id!: UUID;

  @Expose()
  relationshipType?: HouseholdMemberRelationshipTypeEnum;

  @Expose()
  adoptionYear?: number;

  @Expose()
  parentsRelationship?: boolean;

  @Expose()
  otherParentHouseholdStatus?: boolean;

  @Expose()
  otherParentPersonalStatus?: OtherParentPersonalStatusEnum;

  @Expose()
  relationshipDynamics?: RelationshipDynamicsEnum;

  @Expose()
  currentAddressType?: CurrentAddressTypeEnum;

  @Expose()
  familyLivesWithUser?: boolean;

  @Expose()
  familyLivesInCareFacility?: boolean;

  @Expose()
  workingParents?: boolean;
}
